<div class="col-lg-6" >
    <div style="height: 470px;" [ngClass]="{ editGridDiv: !isAddForm, newGridDiv: isAddForm }" >
        <dx-data-grid (onContentReady)="onContentReadyAssigned($event)" #dataGridAssignedVehicles
        noDataText="" [dataSource]="AssignedVehicles" [allowColumnResizing]="false"
        [columnAutoWidth]="false" [(selectedRowKeys)]="assignedVehicleSelected" [columns]="vehicleColumnConfig">
            <dxo-selection [selectAllMode]="allMode" [showCheckBoxesMode]="checkBoxesMode"
                mode="multiple"></dxo-selection>
            <dxo-filter-row [visible]="true"> </dxo-filter-row>
            <dxo-scrolling mode="standard" showScrollbar="onHover"> </dxo-scrolling>
            <dxo-sorting mode="single"> </dxo-sorting>
            <dxo-paging [pageSize]="10"> </dxo-paging>
        </dx-data-grid>
    </div>
</div>

<div class="col-lg-1 pl-0">
    <div class="left-arrow text-center">
        <a *ngIf="!unassignedVehicleSelected.length">
            <img class="arrow-move" src="assets/Content/Images/Icons/arrow_left.svg">
        </a>
        <div *ngIf="unassignedVehicleSelected.length">
            <a (click)="assignVehicles()">
                <img class="arrow-move active" src="assets/Content/Images/Icons/arrow_left_active.svg">
            </a>
        </div>
    </div>
    <div class="right-arrow text-center">
        <a *ngIf="!assignedVehicleSelected.length">
            <img class="arrow-move" src="assets/Content/Images/Icons/arrow_right.svg">
        </a>
        <a (click)="unassignVehicles()" *ngIf="assignedVehicleSelected.length">
            <img class="arrow-move active" src="assets/Content/Images/Icons/arrow_right_active.svg">
        </a>
    </div>

</div>
<div class="col-lg-5 pl-0">
    <div class="gridDiv" style="height: 470px;">
        <dx-data-grid #dataGridUnassignedVehicles (onContentReady)="onContentReadyUnAssigned($event)" noDataText=""
        [dataSource]="UnAssignedVehicles" [allowColumnResizing]="false"
        [columnAutoWidth]="false" [(selectedRowKeys)]="unassignedVehicleSelected"
        [columns]="vehicleColumnConfig">
            <dxo-selection [selectAllMode]="allMode" [showCheckBoxesMode]="checkBoxesMode"
                mode="multiple"></dxo-selection>
            <dxo-filter-row [visible]="true"> </dxo-filter-row>
            <dxo-scrolling mode="standard" showScrollbar="onHover"> </dxo-scrolling>
            <dxo-sorting mode="single"> </dxo-sorting>
            <dxo-paging [pageSize]="10"> </dxo-paging>
        </dx-data-grid>
    </div>
</div>
